/**
 * Fog Mode.
 */
export enum FogMode {
  /** Disable fog. */
  None,
  /** Linear fog. */
  Linear,
  /** Exponential fog. */
  Exponential,
  /** Exponential squared fog. */
  ExponentialSquared
}
